// Forma serializzata del flusso: cio' che l'editor invia al backend e cio' che
// confronta per capire se ci sono modifiche non salvate.
import { stripInternalNodeData } from './flowExitNodes';

/**
 * Stato che Vue Flow aggiunge ai nodi a runtime (misure, posizione calcolata,
 * selezione, drag): cambia senza che l'utente tocchi il flusso. E' la lista che
 * scarta `toObject()` di Vue Flow, piu' `initialized`.
 */
const VUE_FLOW_RUNTIME_NODE_KEYS = ['computedPosition', 'handleBounds', 'dimensions', 'selected', 'dragging', 'resizing', 'initialized', 'isParent', 'events'];

/**
 * Archi nella forma persistita. Vue Flow aggiunge agli archi stato di runtime
 * (`selected`, `events`) e i riferimenti completi ai nodi collegati
 * (`sourceNode`/`targetNode`): niente di tutto questo va salvato.
 */
export function serializeFlowEdges(edges = []) {
  return edges.map(e => ({
    id: e.id,
    source: e.source,
    target: e.target,
    sourceHandle: e.sourceHandle ?? null,
    targetHandle: e.targetHandle ?? null,
    ...(e.type ? { type: e.type } : {}),
    ...(e.label ? { label: e.label } : {}),
    ...(e.data ? { data: e.data } : {}),
  }));
}

/**
 * Impronta del flusso per il rilevamento delle modifiche non salvate: solo cio'
 * che l'utente puo' cambiare. Niente chiavi interne dell'editor ne' stato di
 * runtime di Vue Flow (nemmeno quello dei nodi che gli archi portano con se'),
 * cosi' selezionare o rimisurare un nodo, o riscriverne badge e marker dopo il
 * salvataggio, non conta come modifica.
 */
export function serializeFlowState({ name, nodes = [], edges = [] }) {
  return JSON.stringify({
    flowName: name,
    nodes: stripInternalNodeData(nodes).map(node => {
      for (const key of VUE_FLOW_RUNTIME_NODE_KEYS) delete node[key];
      return node;
    }),
    edges: serializeFlowEdges(edges),
  });
}
